// extracted by mini-css-extract-plugin
export var container = "YearHeading-module--container--3a5b4";
export var content = "YearHeading-module--content--d3ebe";
export var notes = "YearHeading-module--notes--ba737";
export var subheading = "YearHeading-module--subheading--467c1";
export var year = "YearHeading-module--year--65a1e";